<template>
  <div class="user-item" @click.stop="handleUserClick">
    <Avatar
      :avatar-index="user.avatar || user.avatarIndex"
      size="medium"
      class="user-avatar"
      :user-id="user.uid"
      :clickable="true"
      :enable-navigate="true"
      :avatar-frame="user.avatar_frame"
    />
    <span class="user-username">{{ user.username }}</span>
    <button
      v-if="showFollowButton"
      class="follow-btn"
      :class="{ followed: user.is_following }"
      @click.stop="handleFollowClick"
    >
      {{
        user.is_following ? t("profile.followed") : "+ " + t("profile.follow")
      }}
    </button>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
import Avatar from "./Avatar.vue";

const { t } = useI18n();
const router = useRouter();

const props = withDefaults(
  defineProps<{
    user: {
      id: number;
      uid: number;
      username: string;
      avatar?: number;
      avatarIndex?: number;
      is_following?: boolean;
      avatar_frame?: number;
    };
    showFollowButton?: boolean;
  }>(),
  {
    showFollowButton: true,
  }
);

const emit = defineEmits<{
  (e: "follow", user: any): void;
  (e: "userClick", user: any): void;
}>();

const handleUserClick = () => {
  emit("userClick", props.user);
  router.push(`/user/${props.user.uid}`);
};

const handleFollowClick = () => {
  emit("follow", props.user);
};
</script>

<style scoped lang="scss">
.user-item {
  display: flex;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #f8f8f8;
  }
}

.user-avatar {
  margin-right: 16px;
}

.user-username {
  flex: 1;
  font-size: 16px;
  color: #222;
}

.follow-btn {
  margin-left: auto;
  padding: 2px 10px;
  border: 1px solid #dd8632;
  background: transparent;
  color: #dd8632;
  border-radius: 20px;
  font-size: 14px;
  outline: none;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  cursor: pointer;

  &.followed {
    background: #f5f5f5;
    color: #999;
    border: 1px solid #ddd;
  }

  &:hover:not(.followed) {
    background: #dd8632;
    color: #fff;
  }
}
</style>
